<template>
  <div>
    <div class="public-table-but__left">
      <div class="item">
        <!-- <em>筛选：</em> -->
        <div class="item-wp">
          <div class="item-son" v-if="searchShow">
            <el-input
                clearable
                v-model="listParams.searchKey"
                clas="input_search"
                placeholder="搜索关键字"
                style="width: 180px"
                @keyup.enter.native="SearchServiceList"
            ></el-input>
            <el-select
                v-model="listParams.type"
                clearable
                placeholder="请选择类型"
                style="width: 180px;margin: 0 10px"
            >
              <el-option label="银行卡" value="bank"></el-option>
              <el-option label="支付宝" value="alipay"></el-option>
              <el-option label="微信" value="wxpay"></el-option>
            </el-select>
            <el-select
                v-model="listParams.status"
                clearable
                placeholder="请选择状态"
                style="width: 180px"
            >
              <el-option label="正常" value="1"></el-option>
              <el-option label="禁用" value="0"></el-option>
            </el-select>
          </div>
          <div class="item-son" v-if="searchShow">
            <el-button type="primary" @click="queryTableData"
            >查询 <i class="el-icon-search"></i>
            </el-button>
          </div>
          <div class="item-son" v-if="addShow">
            <el-button type="primary" @click="handleClick('add')"
            >新增 <img src="@assets/images/add-icon.png" alt=""/>
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="public-table-data">
      <el-table
          ref="multipleTable"
          size="medium"
          :data="tableData"
          border
          style="width: 100%"
          row-key="menuId"
          v-loading="loading"
      >
        <el-table-column prop="icon" label="ICON" width="80" align="center">
          <template slot-scope="scope">
            <img
                :src="scope.row.icon"
                alt=""
                style="width: 20px; height: 20px"
            />
          </template>
        </el-table-column>
        <el-table-column prop="code" label="标识" width="120" align="center">
        </el-table-column>
        <el-table-column prop="name" label="名称" width="200" align="center">
        </el-table-column>
        <el-table-column prop="descr" label="说明" width="200" align="center">
        </el-table-column>
        <el-table-column prop="seq" label="序号" width="50" align="center">
        </el-table-column>
        <el-table-column prop="code" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <template>
              <el-switch
                  :disabled="statusShow"
                  v-model="scope.row.status"
                  :active-value="1"
                  :inactive-value="0"
                  @change="changeSwitch(scope.row)"
              >
              </el-switch>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" min-width="150">
          <template slot-scope="scope">
            <el-button
                size="mini"
                @click="handleClick('edit', scope.row)"
                type="warning"
                plain
                v-if="editShow"
            >编辑
            </el-button
            >
            <el-button
                size="mini"
                @click="handleDelete(scope.row)"
                type="primary"
                plain
            >删除
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="roleRight_pagenation" style="padding: 30px 0 20px;text-align: center">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pages.pageNo"
          :page-sizes="[PAGE_SIZE, 15, 20, 25]"
          :page-size="pages.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pages.count"
      >
      </el-pagination>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
        title="新增/编辑支付类型"
        :visible.sync="dialogVisible"
        width="460px"
        :close-on-click-modal="false"
        class="public-dialog "
    >
      <div class="public-dialog-form xq_checkColor">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <el-form-item label="类型" prop="type">
            <el-select
                v-model="params.type"
                clearable
                placeholder="请选择类型"
                style="width: 130px"
            >
              <el-option label="银行卡" value="bank"></el-option>
              <el-option label="支付宝" value="alipay"></el-option>
              <el-option label="微信" value="wxpay"></el-option>
            </el-select>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="标识" prop="code">
                <el-input
                    placeholder="请填写支付类型标识"
                    v-model="params.code"
                    :disabled="clickType == 'edit' ? true : false"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="icon">
                <!--图片部分-->
                <div class="screenshot">
              <span
                  v-for="(imgUrl, index) in srcList"
                  :key="index"
                  class="slideshow"
              >
                <el-image
                    style="width: 37px; height: 37px; border-radius: 6px"
                    :src="imgUrl"
                    fit="cover"
                    @click="getPolicy"
                    v-loading="imgLoading"
                />
              </span>
                  <div
                      class="up-btn"
                      style="width: 37px; height: 37px; line-height: 37px"
                      @click="getPolicy"
                      v-if="isMoer"
                      v-loading="imgLoading"
                  >
                    <i class="el-icon-plus" style="font-size: 14px"></i>
                  </div>
                </div>
                <input type="file" ref="file" @change="getFile"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="名称" prop="name">
            <el-input
                placeholder="请填写支付类型名称"
                v-model="params.name"
            ></el-input>
          </el-form-item>
          <el-form-item label="说明">
            <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入说明"
                v-model="params.descr"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="排序" prop="seq">
            <el-input
                placeholder="请填写排序序号"
                v-model.number="params.seq"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {PAGE_SIZE, FILE_ROOT, JOB_STATUS} from "@config";
import {ossUpload} from "@utils/filters/upload";
import {isEmpty} from "../../utils/tools";
import OperationConfirmation from "../../components/OperationConfirmation";

export default {
  components: {OperationConfirmation},
  data() {
    return {
      PAGE_SIZE,
      isEmpty,
      tableData: [],
      listParams: {},
      params: {},
      dialogVisible: false,
      total: 0,
      loading: false,
      clickType: "",
      pages: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      rules: {
        type: [
          {required: true, message: "请选择类型", trigger: "change"},
        ],
        name: [
          {required: true, message: "请填写支付类型名称", trigger: "change"},
        ],
        code: [
          {required: true, message: "请填写标识", trigger: "change"},
        ],
      },

      srcList: [],
      isMoer: true,
      imgLoading: false,
      numType: false,
      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      searchShow: false,
    };
  },
  mounted() {
    this.queryTableData();
    this.getPermissionButtonList()
  },
  computed: {},
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.srcList = [];
        this.isMoer = true;
      }
    },
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'finance:account:query') {
            this.searchShow = true
          }
          if (item.code == 'finance:account:add') {
            this.addShow = true
          }
          if (item.code == "finance:channel:delete") {
            this.deleteShow = true
          }
          if (item.code == "finance:channel:edit") {
            this.editShow = true
          }
          if (item.code == "finance:channel:status") {
            this.statusShow = false
          }
        })
      }
    },
    /**
     * 获取列表
     */
    async queryTableData() {
      this.loading = true;
      const {data: resData} = await this.$get("/bank/list", {
        params: {
          ...this.listParams,
          ...this.pages,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.tableData = resData.data;
      this.pages.count = resData.page.count
    },
    /**
     * 修改支付类型状态
     */
    async changeSwitch(b) {
      const {data: resData} = await this.$put(
          `/bank/info/status/${b.bankId}`
      );
      if (resData.result != 200) return;
      this.$message.success('操作成功')
    },

    /**
     * 表格按钮点击
     */
    async handleClick(type, row = {}) {
      this.clickType = type;
      if (type == "edit") {
        //编辑
        const {data: resData} = await this.$get(
            `/bank/info/${row.bankId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.params = resData.data;
        if (!isEmpty(this.params.icon)) {
          this.srcList[0] = this.params.icon;
          this.isMoer = false;
        }
        this.dialogVisible = true;
      }
      if (type == "add") {
        this.params = {};
        this.dialogVisible = true;
      }
    },

    //查询
    SearchServiceList() {
      this.pages.pageNo = 1
      delete this.pages['count']
      this.getserviceList()
    },
    /**
     * 编辑/增加
     */
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "add" || this.clickType == "addNext") {
            const {data: resData} = await this.$post(
                "/bank/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );

            if (resData.result != 200) return;
            this.queryTableData();
            this.dialogVisible = false;
            this.$message.success("添加成功!");
            this.params = {};
          } else {
            const {data: resData} = await this.$put(
                "/bank/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.queryTableData();
            this.dialogVisible = false;
            this.$message.success("修改成功!");
          }
        });
      });
    },

    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/bank/info/${row.bankId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.$message.success("删除成功!");
        this.queryTableData();
      });
    },
    //分页
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getserviceList();
    },
    handleCurrentChange(val) {
      this.pages.pageNo = val;
      this.getserviceList();
    },
    /**
     * 阿里云OSS签名
     */
    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    async getFile() {
      this.imgLoading = true;
      const that = this;
      const {data: resData} = await this.$get("aliyun/oss/sign");
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.file.files[0],
          resData.data,
          "one" //'more','one'
      );
      this.imgLoading = false;
      this.isMoer = false;
      this.srcList = addRoutes;
      this.params.icon = this.srcList[0];
    },
  },
};
</script>
<style lang="scss" scoped>
.icon-width {
  width: 20px;
  height: 20px;
  display: inline-block;
}

.screenshot {
  position: relative;
}

.xq_checkColor {
  ::v-deep .el-color-picker__trigger {
    width: 60px !important;
    height: 60px !important;
  }
}
</style>